import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";

export default function AuthCallback() {
  const { session, profile, whitelistError, syncError, loading, signOut, syncProfile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (session && profile) {
      navigate("/dashboard", { replace: true });
    } else if (!session && !whitelistError) {
      navigate("/login", { replace: true });
    }
  }, [session, profile, whitelistError, loading, navigate]);

  if (whitelistError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md p-8 space-y-5" data-testid="not-whitelisted-card">
          <div>
            <h2 className="text-xl font-bold">Akses ditolak</h2>
            <p className="text-sm text-muted-foreground mt-2" data-testid="whitelist-error-msg">
              {whitelistError}
            </p>
          </div>
          <Button
            data-testid="logout-after-reject"
            variant="outline"
            className="w-full"
            onClick={async () => {
              await signOut();
              navigate("/login", { replace: true });
            }}
          >
            Kembali ke Login
          </Button>
        </Card>
      </div>
    );
  }

  if (syncError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md p-8 space-y-5" data-testid="sync-error-card">
          <div>
            <h2 className="text-xl font-bold">Gagal memuat profil</h2>
            <p className="text-sm text-muted-foreground mt-2" data-testid="sync-error-msg">
              Tidak bisa menghubungi server. Coba lagi atau kembali ke halaman login.
            </p>
          </div>
          <Button
            data-testid="retry-sync-button"
            className="w-full"
            onClick={async () => {
              await syncProfile();
            }}
          >
            Coba Lagi
          </Button>
          <Button
            data-testid="logout-after-sync-error"
            variant="outline"
            className="w-full"
            onClick={async () => {
              await signOut();
              navigate("/login", { replace: true });
            }}
          >
            Kembali ke Login
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-sm text-muted-foreground" data-testid="auth-callback-loading">
        Memproses login...
      </div>
    </div>
  );
}
